import { Navigate } from "react-router-dom";
import { LoadingPage } from "@/components/LoadingPage/LoadingPage";
import { useAppSelector } from "@/hooks/types";
import { useAppData } from "@/hooks/useAppData";
import { useTenantData } from "@/hooks/useTenantData";
import { getTenant } from "@/store/tenant/selectors";
import { getUserDetails } from "@/store/user/selectors";
import { UsingReactChildren } from "@/types";
import { AppRoutes } from "@/types/routes";
import { getIsAdminRole, getIsSuperAdminRole } from "@/utils/getIsRole";

export const AdminProtectedRoute = ({
    children,
    requiredPermissionLevel = "admin",
}: UsingReactChildren & {
    requiredPermissionLevel?: "admin" | "superAdmin";
}) => {
    const user = useAppSelector(getUserDetails);
    const { isLoading: isAppDataLoading } = useAppData();
    const { isLoading: isTenantLoading } = useTenantData();

    const isSuperAdmin = getIsSuperAdminRole(user?.role);
    const isAdmin = getIsAdminRole(user?.role);
    const tenant = useAppSelector(getTenant);

    if (isAppDataLoading || isTenantLoading) {
        return <LoadingPage />;
    }

    // Show loading while user data is being fetched
    if (user === undefined || !tenant) {
        return <LoadingPage />;
    }

    if (requiredPermissionLevel === "superAdmin" && !isSuperAdmin) {
        return <Navigate to={AppRoutes.Dashboard} />;
    }

    if (requiredPermissionLevel === "admin" && !isAdmin && !isSuperAdmin) {
        return <Navigate to={AppRoutes.Dashboard} />;
    }

    return children;
};
